import toast from 'react-hot-toast';
import Core from '../core';
import { Axios, AxiosError, AxiosResponse } from 'axios';
const version = 'v2';

function getempshiftservicesdetails(date: any, empid: any, companyId: any) {
  return new Promise((resolve, reject) => {
    const api = Core.getInstance().api();
    api
      .get(
        `/v2/shift-modules/employee-shift-details?employeeId=${empid}&shiftDate=${date}&comapny_id=${companyId}&limit=10&locale=${localStorage.getItem(
          'applang',
        )}`,
      )
      .then((result) => {
        //console.log('result------------', result?.data);
        return resolve(result.data);
      })
      .catch((err) => {
        return reject(err);
      });
  });
}

function getListAttExceptionConfig(payload: any) {
  return new Promise((resolve, reject) => {
    const api = Core.getInstance().api();
    const queryParams = new URLSearchParams({
      locale: localStorage.getItem('applang') || 'en',
      ...payload,
    }).toString()
    api
      .get(
        `v2/config/configs?${queryParams}`,
      )
      .then((result) => {
        //console.log('result------------', result?.data);
        return resolve(result.data);
      })
      .catch((err) => {
        return reject(err);
      });
  });
}


function createAttendanceExceptionRequest(payload: any) {
  return new Promise((resolve, reject) => {
    const api = Core.getInstance().api();
    const queryParams = new URLSearchParams({
      locale: localStorage.getItem('applang') || 'en',
      ...payload,
    }).toString();
    api
      .post(
        `/v2/attendance-exception-request?${queryParams}`,
      )
      .then((result) => {
        return resolve(result.data);
      })
      .catch((err) => {
        return reject(err);
      });
  });
}

function getAttendanceExceptionList(payload: any) {
  return new Promise((resolve, reject) => {
    const api = Core.getInstance().api();
    const queryParams = new URLSearchParams({
      locale: localStorage.getItem('applang') || 'en', 
      ...payload,
    }).toString();
    api
      .get(
        `/v2/attendance-exception-details?${queryParams}`,
      )
      .then((result) => {
        return resolve(result?.data?.data);
      })
      .catch((err) => {
        return reject(err);
      });
  });
}

function isExceptionEnabled(payload: any) {
  return new Promise((resolve, reject) => {
    const api = Core.getInstance().api();
    const queryParams = new URLSearchParams({
      locale: localStorage.getItem('applang') || 'en', 
      ...payload,
    }).toString();
    api
      .get(
        `/v2/attendanceException/isEnabled?${queryParams}`,
      )
      .then((result) => {
        return resolve(result?.data?.data);
      })
      .catch((err) => {
        return reject(err);
      });
  });
}
export const attendanceException = {
  getempshiftservicesdetails,
  createAttendanceExceptionRequest,
  getAttendanceExceptionList,
  isExceptionEnabled,
  getListAttExceptionConfig
};
